export default __webpack_public_path__ + "static/media/canaryPointLogo.3f7ba18c.png";